import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
  standalone: false
})
export class PhoneFormatPipe implements PipeTransform {

  transform(value: string, format: 'standard' | 'bracket' = 'standard'): string {
    if (!value) return value;

    const phoneNumber = value.replace(/\D/g, '');

    if (phoneNumber.length !== 10) {
      return value;
    }

    if (format === 'bracket') {
      return `(${phoneNumber.substring(0, 3)})${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`;
    }

    // default: standard
    return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`;
  }

}
